import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { RotateSpinLoader } from "react-css-loaders2";

import colors from "../colors";

const breadcrumbsSchema = {
  offers: {
    stateName: "offers",
    name: "Oferty",
    children: {
      add: {
        name: "Nowa oferta"
      },
      uid: {
        name: "dynamic",
        key: [["title"]],
        normalize: value => {
          if (value && value.length > 20) {
            return value.substr(0, 20) + "...";
          } else {
            return value;
          }
        }
      }
    }
  },
  applications: {
    stateName: "applications",
    name: "Aplikacje",
    children: {
      uid: {
        name: "dynamic",
        key: [["firstName"], ["lastName"]]
      }
    }
  }
};

const getObject = (object, element) => {
  if (object === undefined) {
    return breadcrumbsSchema[element];
  } else {
    let el = object.children[element];
    if (el !== undefined) {
      return el;
    } else {
      return object.children["uid"];
    }
  }
};

class Breadcrumbs extends Component {
  render() {
    const { entities } = this.props;

    let names = [];
    let breadcrumbs = [];
    let path = window.location.pathname;

    const bcmbs = path.split("/");
    bcmbs.shift();

    let obj = undefined;
    for (let i = 0; i < bcmbs.length; i++) {
      obj = getObject(obj, bcmbs[i]);
      if (obj === undefined) {
        continue;
      }
      if (!obj.stateName && i === 0) {
        continue;
      }
      names[i] = obj.stateName;
      let name = obj.name;
      let path = "";

      for (let j = 0; j <= i; j++) {
        path += "/" + bcmbs[j];
      }

      if (name === "dynamic") {
        const first = getObject(undefined, bcmbs[0]);
        const values = obj.key.map(item => {
          return [first.stateName, bcmbs[i], ...item];
        });

        let loading = false;
        name = "";
        values.forEach(item => {
          const word = entities.getIn(item);
          if (!word) {
            loading = true;
            return;
          } else {
            name += word + " ";
          }
        });
        if (loading) {
          name = <StyledLoader size={1.5} />;
        } else if (obj.normalize) {
          name = obj.normalize(name);
        }
      }

      let bc = {
        name: name,
        path: path,
        depth: i,
        isVisible: obj.isVisible,
        noLink: obj.noLink
      };
      if (obj.isVisible !== false) {
        breadcrumbs.push(bc);
      }
    }

    const depth = breadcrumbs.length;
    return (
      depth > 1 && (
        <StyledBreadcrumb>
          {breadcrumbs.map((item, index) => {
            return (
              <StyledBreadcrumbItem key={index} active={index === depth - 1}>
                {index !== depth - 1 &&
                !item.noLink && <Link to={item.path || ""}>{item.name}</Link>}
                {(index === depth - 1 || item.noLink) && item.name}
              </StyledBreadcrumbItem>
            );
          })}
        </StyledBreadcrumb>
      )
    );
  }
}
const StyledLoader = styled(RotateSpinLoader)`
  margin: 0;
  display: inline-block;
  top: 2px;
`;

const StyledBreadcrumb = styled(Breadcrumb)`
  background-color: ${colors.bodyBg};
  margin-bottom: 0px;
  user-select: none;
  padding-bottom: 0px;
`;
const StyledBreadcrumbItem = styled(BreadcrumbItem)`
  font-size: 13px;
  font-weight: 400;
  color: #5e5e5e;
`;

export default connect(
  state => ({
    entities: state.entities
  }),
  {}
)(Breadcrumbs);



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs.js